module.exports = __webpack_public_path__ + "img/弈剑女.fcf41afd.png";